import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import Button from '../Button';

const AccountNotFound = () => {
  const backToRootHandler = () => {
    const hostname = window.location.host.split('.');
    const lastItem = hostname[hostname.length - 1];
    const secondLastItem = hostname[hostname.length - 2];
    const rootDomain = `${secondLastItem}.${lastItem}`;
    window.location.href = `${window.location.protocol}//${rootDomain}`;
  };

  return (
    <div className='mx-auto flex flex-col bg-white px-5 py-6 rounded-md max-w-xl text-center justify-center items-center shadow-lg'>
      <div className='bg-red-50 p-4 rounded-full my-4'>
        <ExclamationCircleIcon className='h-10 w-10 text-tertiaryColor-normal' />
      </div>
      <h2 className='m-0'>Account not found.</h2>
      <p className='mt-2 mb-5'>
        Uh oh! we are unable to find your account.Please make sure you are in correct account subdomain in your browser URL address bar.
      </p>
      <div>
        <Button label='Go back to home' btnStyle='btn-primary' type='button' onClick={backToRootHandler} />
      </div>
    </div>
  );
};

export default AccountNotFound;
